<template>
  <div class="p-3 card">
    <label class="titlePage">Status da Classificação</label>

    <fccTable
      v-if="statusDaConfiguracao"
      striped
      hover
      responsive
      :fields="fields"
      :items="[statusDaConfiguracao]"
    />

    <div class="text-right mb-3">
      <fccButton @click="cancelar" class="mr-2" v-if="mostraBotaoCancelar">Cancelar</fccButton>
      <fccButton @click="editar" class="mr-2" v-if="mostraBotaoEditar">{{
        labelsSystem.editar
      }}</fccButton>
      <fccButton @click="finalizar" v-if="mostraBotaoFinalizar">Finalizar</fccButton>
    </div>
  </div>
</template>
  
<script>
import store from '../../../store/index'
import axios from 'axios'
import { TP_SITUACAO } from './constantes'

export default {
  props: ['etapa'],
  data() {
    return {
      fields: [
        { key: 'detapa', label: 'Etapa' },
        { key: 'nomefuncionario', label: 'Técnico' },
        { key: 'datasituacao', label: 'Data' },
        { key: 'dsituacao', label: 'Situação' }
      ]
    }
  },
  computed: {
    situacao() {
      return this.status?.find((item) => item.tpEtapa === this.etapa)?.tpSituacao
    },
    mostraBotaoCancelar() {
      return this.situacao && this.situacao !== 3
    },
    mostraBotaoEditar() {
      return this.situacao && this.situacao !== 2
    },
    mostraBotaoFinalizar() {
      return !this.situacao || this.situacao === 2
    },
    status() {
      return store.state.localDeProva.listaStatus
    },
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    statusDaConfiguracao() {
      return store.state.localDeProva.statusAtual
    }
  },
  created() {
    store.dispatch('localDeProva/fetchStatusAtual', this.dadosLoginSession.fccTokenHeaders)
  },
  methods: {
    finalizar() {
      const payload = {
        idLocalConfig: this.configuracao.idlocalconfig,
        tpEtapa: this.etapa,
        tpSituacao: TP_SITUACAO.FINALIZADO,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      this.callConfirm('Deseja finalizar a configuração?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .post(
              store.state.baseUrlLocalDeProva + 'LocalExameConfig/FinalizarLocalExameConfig',
              payload,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() =>
              store.dispatch(
                'localDeProva/fetchListaStatus',
                this.dadosLoginSession.fccTokenHeaders
              )
            )
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },
    cancelar() {
      const payload = {
        idLocalConfig: this.configuracao.idlocalconfig,
        tpEtapa: this.etapa,
        tpSituacao: TP_SITUACAO.CANCELADO,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      axios
        .post(
          store.state.baseUrlLocalDeProva + `LocalExameConfig/CancelarLocalExameConfig`,
          payload,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() =>
          store.dispatch('localDeProva/fetchListaStatus', this.dadosLoginSession.fccTokenHeaders)
        )
        .catch(this.setErrorSystem)
    },
    editar() {
      const payload = {
        idLocalConfig: this.configuracao.idlocalconfig,
        tpEtapa: this.etapa,
        tpSituacao: TP_SITUACAO.EDICAO,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      axios
        .put(
          store.state.baseUrlLocalDeProva + `LocalExameConfig/EditarLocalExameConfig`,
          payload,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          store.dispatch('localDeProva/fetchListaStatus', this.dadosLoginSession.fccTokenHeaders)
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>
  